import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Modal from '../components/Modal';
import SellerQuickSaleForm from '../components/SellerQuickSaleForm';
import SellerDetailedSaleForm from '../components/SellerDetailedSaleForm';
import '../styles/Sales.css';

const SellerSales = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Obtener el tipo de venta de la navegación (rápida o detallada)
  const [saleType, setSaleType] = useState('quick');
  
  // Estados para modal
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [modalType, setModalType] = useState('error');
  
  // Actualizar el tipo de venta cuando cambia la ubicación
  useEffect(() => {
    // Si hay un estado en la ubicación, usar ese tipo de venta
    if (location.state && location.state.saleType) {
      setSaleType(location.state.saleType);
    }
  }, [location]);
  
  const showModal = (title, message, type = 'error') => {
    setModalTitle(title);
    setModalMessage(message);
    setModalType(type);
    setModalOpen(true);
  };
  
  const handleSaleAdded = () => {
    showModal('Éxito', 'Venta registrada exitosamente', 'success');
  };
  
  const handleCancel = () => {
    navigate('/seller-sales-type');
  };
  
  return (
    <div className="sales-container">
      <Modal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title={modalTitle}
        message={modalMessage}
        type={modalType}
      />
      
      <header className="sales-header">
        <h1>Registro de Ventas {saleType === 'quick' ? 'Rápida' : 'Detallada'}</h1>
        <button onClick={() => navigate('/seller-dashboard')} className="back-btn">
          Volver al Dashboard
        </button>
      </header>
      
      <div className="sales-content">
        {saleType === 'quick' ? (
          <SellerQuickSaleForm 
            onSaleAdded={handleSaleAdded} 
            onCancel={handleCancel} 
          />
        ) : (
          <SellerDetailedSaleForm 
            onSaleAdded={handleSaleAdded} 
            onCancel={handleCancel} 
          />
        )}
      </div>
    </div>
  );
};

export default SellerSales;
